import React, { useContext } from "react";
import { EyeSlashIcon, EyeIcon } from "@heroicons/react/24/outline";
import { PrivacyModeContext } from "@/contexts";
import Alerts from "./Alerts/Alerts";
import { Link } from "react-router-dom";
import { FEATURE_FLAG_KEYS, useFeatureFlag, usePlan } from "@moonscape/shared";
import { Tooltip } from "@/components/ui/tooltip";
import { Band, Lab, Tag } from "@/components/ms";

/**
 * The per-screen status strip that sits under the app header: the screen's name
 * on the left, plan / privacy / alerts on the right.
 */
export const ScreenHeader = ({ heading }) => {
  const { privacyMode, setPrivacyMode } = useContext(PrivacyModeContext);
  const { data: plan, isQueryloading, error } = usePlan({});
  const showIAP = useFeatureFlag(FEATURE_FLAG_KEYS.WEB_SHOW_IAP);

  if (!heading) {
    return null;
  }

  const Icon = privacyMode ? EyeSlashIcon : EyeIcon;

  return (
    <Band
      className="print:hidden"
      left={<Lab className="truncate text-ms-ink">{heading}</Lab>}
      right={
        <>
          {showIAP && !isQueryloading && !error && plan?.planName && (
            <Tooltip
              title={`You are on the ${plan.planName} plan${
                plan?.expiredAt
                  ? `, which expires ${new Date(plan.expiredAt).toUTCString()}`
                  : ""
              }`}
            >
              <Link to="/plans">
                <Tag tone="pos">{plan.planName}</Tag>
              </Link>
            </Tooltip>
          )}

          <button
            type="button"
            onClick={() => setPrivacyMode(!privacyMode)}
            aria-label={privacyMode ? "Show amounts" : "Hide amounts"}
            className="grid h-9 w-9 place-items-center text-ms-mute transition-colors hover:text-ms-ink"
          >
            <Icon className="h-[18px] w-[18px]" aria-hidden="true" />
          </button>

          <Alerts />
        </>
      }
    />
  );
};
